import { Injectable, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';

@Injectable()
export class EmployerFormService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    /**
     * Update a Employer entity
     * @param employerForm inputform with data for the Employer to be created
     */
    updateEmployer(employerForm) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/'+ employerForm.id;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('employerBody', JSON.stringify(employerForm));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Retrieves data about the employer specified by its uuid
     * @param uuid The uuid of the employer to be retrieved
     */
    getEmployerById(uuid) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/' + uuid;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Create a new employer entity
     * @param employerForm inputform with data for the employer to be created
     */
    createEmployer(employerForm) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('employerBody', JSON.stringify(employerForm));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }
    
    
    getAllDepartments() {
        this.authService.isTokenValid();
      const url = this.authService.getResourceURL() + '/api/v1/govdepartment/';
      let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }
    
    govUpdate(ministry): Observable<any>{
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/govdepartment/' + ministry.id ;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('govBody', JSON.stringify(ministry));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }
    updateGovName(ministry, ministryId, oldName, type, newName, entityName): Observable<any>{
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/govdepartment/nameupdate/' + ministryId ;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('govBody', JSON.stringify(ministry))
        .set('oldName', oldName)
        .set('type', type)
        .set('newName', newName)
        .set('entityName', entityName);

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get a GovMinistry matching the name.
     * @param name Name of the ministry.
     */
    getGovMinistryByName(name: string): Observable<any> {
        this.authService.isTokenValid();

        const url = this.authService.getResourceURL() + '/api/v1/govdepartment/name/' + name;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, { headers: requestHeaders, responseType: 'json' })
    }

    /**
     * Get a ministry matching the ID and containing an entity matching the name.
     * @param id Id of the ministry.
     * @param entityName Name of the entity.
     */
    getGovMinistryByIdAndEntityName(id: string, entityName: string): Observable<any> {
        this.authService.isTokenValid();

        //const url = this.authService.getResourceURL() + '/api/v1/govdepartment/' + id + '/entity/' + entityName;
        const url = this.authService.getResourceURL() + '/api/v1/govdepartment/byName/' + id + '/entity/' + entityName;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, { headers: requestHeaders, responseType: 'json' })
    }

    /**
     * Get a ministry matching the ID, entity ID and the section name.
     * @param ministryId ID of the ministry.
     * @param entityId ID of the entity.
     * @param sectionName Name of the section.
     */
    getGovMinistryByIdAndEntityIdAndSectionName(ministryId: string, entityId: string, sectionName: string): Observable<any> {
        this.authService.isTokenValid();

        //const url = this.authService.getResourceURL() + '/api/v1/govdepartment/' + ministryId + '/entity/section';
        const url = this.authService.getResourceURL() + '/api/v1/govdepartment/byName/' + ministryId + '/entity/section';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const params = new HttpParams()
            .set('entityId', entityId)
            .set('sectionName', sectionName)

        return this.http.get(url, { headers: requestHeaders, params: params, responseType: 'json' })
    }

    /**
     * Adds a GovMinistry.
     * @param govMinistry GovMinistry object.
     */
    addGovMinistry(govMinistry: any): Observable<any> {
        this.authService.isTokenValid();

        const url = `${this.authService.getResourceURL()}/api/v1/govdepartment/`
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('govBody', JSON.stringify(govMinistry))
        return this.http.post(url, body, { headers: requestHeaders, responseType: 'json' })
    }

    /**
     * Adds a GovEntity to a GovMinistry.
     * @param govEntity GovEntity object.
     * @param govMinistryId ID of the parent GovMinistry.
     */
    addGovEntity(govEntity: any, govMinistryId: string): Observable<any> {
        this.authService.isTokenValid();

        const url = `${this.authService.getResourceURL()}/api/v1/gov-entity`
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('govEntity', JSON.stringify(govEntity))
            .set('govMinistryId', govMinistryId)

        return this.http.post(url, body, { headers: requestHeaders, responseType: 'json' })
    }

    /**
     * Adds a GovSection to a GovEntity.
     * @param govSection GovSection object.
     * @param govEntityId ID of the parent GovEntity.
     */
    addGovSection(govSection: any, govEntityId: string): Observable<any> {
        this.authService.isTokenValid();

        const url = `${this.authService.getResourceURL()}/api/v1/gov-section`
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('govSection', JSON.stringify(govSection))
            .set('govEntityId', govEntityId)
        
        return this.http.post(url, body, { headers: requestHeaders, responseType: 'json' })
    }

    /**
     * Deletes the ministry and all associated entities and sections.
     * @param id Id of the ministry.
     */
    deleteGovMinistry(id: string): Observable<any> {
        this.authService.isTokenValid();

        const url = this.authService.getResourceURL() + '/api/v1/govdepartment/ministry/' + id;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Deletes the entity and all associated sections.
     * @param id Id of the entity.
     */
    deleteGovEntity(id: string): Observable<any> {
        this.authService.isTokenValid();
        
        const url = `${this.authService.getResourceURL()}/api/v1/gov-entity/${id}`
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        
        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Deletes the section.
     * @param id Id of the section.
     */
    deleteGovSection(id: string): Observable<any> {
        this.authService.isTokenValid();
        
        const url = `${this.authService.getResourceURL()}/api/v1/gov-section/${id}`
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        
        return this.http.delete(url, { headers: requestHeaders, responseType: 'json' });
    }

    /**
     * Validate if employer by orgNr already exists
     * @param orgNr identification of employer
     * @param countryCode country code of employer
     */
    doesEmployerOrgNrExists(orgNr, countryCode) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/byOrgId/validate/' + orgNr + '/' + countryCode;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Get all employers of any autority type
     * @returns array of authority employers
     */
    getActiveAuthorityEmployers() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/activeAuthorityEmployers';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Get all employers of any autority type
     * @returns array of authority employers
     */
     getActiveEmployers() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/activeEmployers';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Adds a GovMinistry Hierarchy.
     * @param ministry Hierarchy object.
     */
    saveHierarchy(ministry): Observable<any> {
        this.authService.isTokenValid();

        const url = `${this.authService.getResourceURL()}/api/v1/govdepartment/saveHierarchy`
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('govBody', JSON.stringify(ministry))

        return this.http.post(url, body, { headers: requestHeaders, responseType: 'json' })
    }

    /**
     * Update a GovMinistry Hierarchy
     * @param ministry Hierarchy object.
     * @param updateAssos assosiations to update
     * @param softDeleted soft-delete to update
     */
    updateHierarchy(ministry, updateAssos, softDeleted): Observable<any> {
        this.authService.isTokenValid();

        const url = `${this.authService.getResourceURL()}/api/v1/govdepartment/updateHierarchy`
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('govBody', JSON.stringify(ministry))
            .set('updateAssos', JSON.stringify(updateAssos))
            .set('updateDeleted', JSON.stringify(softDeleted))

        return this.http.put(url, body, { headers: requestHeaders, responseType: 'json' })
    }

    getParentEmployers() : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/parentEmployers';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }
}